import * as jsxRuntime from "/Users/dion/dev/git/metapages/metaframes/metaframe-js/client/node_modules/react/jsx-runtime.js"
export const jsx = jsxRuntime.jsx
export const jsxs = jsxRuntime.jsxs
export const Fragment = jsxRuntime.Fragment